// @flow
// eslint-disable-next-line no-restricted-imports
import { getStore } from '@ta/common.state';

/**
 * Module for tracking holistic events. Logic ported from site/js-amd/src/retargeting/util.js
 *
 * @author sdeneen
 * @since August, 2018
 * @see site/js-amd/src/retargeting/util.js
 */

// TA pixel ID for TAMG tracking provider
const PIXEL_ID = 481409672;

const INIT_EVENT_NAME = 'init';
const TRACK_EVENT_NAME = 'track';
const OVERRIDE_EVENT_NAME = 'override';

// Any new events that are added here need to be whitelisted in RetargetingServlet.java
export const EVENTS = {
  PAGEVIEW: 'PAGEVIEW',
  START_BOOKING: 'START_BOOKING',
  BOOKING_CONFIRMATION: 'BOOKING_CONFIRMATION',
  PAGEVIEW_FLIGHT: 'PAGEVIEW_FLIGHT',
  START_BOOKING_FLIGHT: 'START_BOOKING_FLIGHT',
  BOOKING_CONFIRMATION_FLIGHT: 'BOOKING_CONFIRMATION_FLIGHT',
  PAGEVIEW_TRAIN: 'PAGEVIEW_TRAIN',
  START_BOOKING_TRAIN: 'START_BOOKING_TRAIN',
  BOOKING_CONFIRMATION_TRAIN: 'BOOKING_CONFIRMATION_TRAIN',
  PAGEVIEW_PACKAGE: 'PAGEVIEW_PACKAGE',
  START_BOOKING_PACKAGE: 'START_BOOKING_PACKAGE',
  BOOKING_CONFIRMATION_PACKAGE: 'BOOKING_CONFIRMATION_PACKAGE',
  DISPLAY_AD_VIEW: 'DISPLAY_AD_VIEW',
  DISPLAY_AD_CLICK: 'DISPLAY_AD_CLICK',
  META_CLICK: 'META_CLICK',
  IB_CLICK: 'IB_CLICK',
  BL_CLICK: 'BL_CLICK',
  IB_CONVERSION: 'IB_CONVERSION',
  APP_INSTALL: 'APP_INSTALL',
  HOTELS_SP_IMPRESSION: 'HOTELS_SP_IMPRESSION',
  HOTELS_SP_CLICK: 'HOTELS_SP_CLICK',
};

type HolisticEventType = $Keys<typeof EVENTS>;

/**
 * Copies the given data object and adds some common attributes
 * @param data
 * @returns new data object with added attributes
 */
const addCommonHolisticTrackingData = (data: { [string]: any }): { [string]: any } => {
  const state = getStore().getState();
  const { tracking } = state;
  const dataToSend = { ...data };

  if (tracking.drsInfo) {
    dataToSend.drs = tracking.drsInfo;
  }

  if (tracking.uvmScore) {
    dataToSend.uvm = tracking.uvmScore;
  }

  if (state.route.geo) {
    dataToSend.geoid = state.route.geo;
  }

  return dataToSend;
};

/**
 * Track a holistic event with the given type and data attributes
 *
 * @param eventType The type of event to track (see EVENTS at the top of this file)
 * @param data Attribute map to include in tracking event
 */
export const trackHolisticEvent = (eventType: HolisticEventType, data: { [string]: any }) => {
  // not available in unit tests!
  if (global.require) {
    global.require(['trjs!taevents'], () => {
      // eslint-disable-next-line no-restricted-globals
      if (eventType && data && window.taq) {
        const state = getStore().getState();
        const { tracking } = state;

        const dataToSend = addCommonHolisticTrackingData(data);
        // eslint-disable-next-line no-restricted-globals
        window.taq(INIT_EVENT_NAME, PIXEL_ID);

        if (tracking.retargetingUrl) {
          // eslint-disable-next-line no-restricted-globals
          window.taq(OVERRIDE_EVENT_NAME, `//${tracking.retargetingUrl}`);
        }

        if (state.route.page) {
          dataToSend.servlet_name = state.route.page;
        }

        // eslint-disable-next-line no-restricted-globals
        window.taq(TRACK_EVENT_NAME, eventType, dataToSend);
      }
    });
  }
};

export default trackHolisticEvent;
